/* =============================================

  Custom JS added by synq-ps.co.jp

=============================================== */

$(document).ready(function () {
  $(".product-swiper__title").each(function () {
    var $title = $(this);
    var text = $title.html().trim();

    // `<br>` が含まれている場合のみ変換
    if (text.includes("<br>") || text.includes("<br/>") || text.includes("<br />")) {
      var newHTML = text.replace(/<br\s*\/?>/gi, '</span><span class="product-swiper__title-sub">');
      $title.html('<span class="product-swiper__title-main">' + newHTML + '</span>');
    }
  });
   // ブログタグの#を削除
  $('.blog_meta.tags a').each(function () {
    var t = $(this).text() || '';
    if (/^#/.test(t.trim())) {
      $(this).text(t.replace(/^#+\s*/, ''));
    }
  });
});

(function() {
  const mySwiper = new Swiper('#js-new-arrivals', {
    slidesPerView: 1.44,
    spaceBetween: 0,
    grabCursor: true,
    pagination: {
      el: '.new-arrivals__wrap .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.new-arrivals__wrap .swiper-button-next',
      prevEl: '.new-arrivals__wrap .swiper-button-prev',
    },
    scrollbar: {
      el: '.new-arrivals__wrap .swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3.33,
      },
      1200: {
        slidesPerView: 4.54,
      }
    },
  });
}());


(function() {
  const mySwiper = new Swiper('#js-ranking', {
    slidesPerView: 1.44,
    // spaceBetween: 24,
    grabCursor: true,
    pagination: {
      el: '.ranking__wrap .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.ranking__wrap .swiper-button-next',
      prevEl: '.ranking__wrap .swiper-button-prev',
    },
    scrollbar: {
      el: '.ranking__wrap .swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3.33,
      },
      1200: {
        slidesPerView: 4.54,
      }
    },
  });
}());


(function() {
  const mySwiper = new Swiper('#js-recommended', {
    slidesPerView: 1.44,
    grabCursor: true,
    pagination: {
      el: '.recommended__wrap .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.recommended__wrap .swiper-button-next',
      prevEl: '.recommended__wrap .swiper-button-prev',
    },
    scrollbar: {
      el: '.recommended__wrap .swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3.33,
      },
      1200: {
        slidesPerView: 4.54,
      }
    },
  });
}());

// top改修
$(document).ready(function() {
  $('.footer-menu__link').each(function() {
    var link = $(this);
    var tabValue = link.attr('data-tab-value'); // data-tab-value の値を取得
    
    // data-tab-value が存在する場合 href にセット
    if (tabValue) {
      link.attr('href', tabValue);
    }
  });
});

// メガメニュー高さ設定
// $(document).ready(function() {

//   $('.dropdown_container').each(function() {
//     const $dropdown = $(this).find('.dropdown');
//     const dropdownHeight = $dropdown.outerHeight(true); // マージン込みの高さ

//     $(this).height(dropdownHeight);
//   });
// });

/* =============================================
商品ページ：yourkindoftechのギャラリーコンテンツ開発
=============================================== */
(function() {
  const mySwiper = new Swiper('#js-yourkindoftech-slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    grabCursor: true,
    pagination: {
      el: '.yourkindoftech__wrap .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.yourkindoftech__wrap .swiper-button-next',
      prevEl: '.yourkindoftech__wrap .swiper-button-prev',
    },
    scrollbar: {
      el: '.yourkindoftech__wrap .swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      799: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      }
    },
  });
}());